<template>
  <div>
    <div v-katex="getLatexFromText(text)"></div>
    {{ getOnlyText(text) }}
  </div>
</template>

<script>
export default {
  props: ['text'],
  name: "latex",
  methods:{
    getLatexFromText(text) {
      if (text.indexOf('$') !== -1) {
        let startIndex = text.indexOf('$');
        let endIndex = text.indexOf(startIndex, '$')
        return text.slice(startIndex + 1, endIndex)
      }
      if (text.indexOf('[') !== -1 && text.indexOf(']') !== -1) {
        let startIndex = text.indexOf('[');
        let endIndex = text.indexOf(startIndex, ']')
        return text.slice(startIndex + 1, endIndex)
      }
      return ""
    },
    getOnlyText(text) {
      if (text.indexOf('$') !== -1) {
        let startIndex = text.indexOf('$');
        let endIndex = text.indexOf(startIndex, '$')
        return text.replace(text.slice(startIndex, endIndex), "").trimRight().slice(0, -1)
      }
      if (text.indexOf('[') !== -1 && text.indexOf(']') !== -1) {
        let startIndex = text.indexOf('[');
        let endIndex = text.indexOf(startIndex, ']')
        return text.replace(text.slice(startIndex, endIndex), "").trimRight(']').slice(0, -1)
      }
      return text
    }
  }
}
</script>

<style scoped>

</style>
